var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "61.09 66.22 319.81 318.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,450.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2050 3834 c-495 -62 -910 -313 -1172 -709 -531 -800 -242 -1876 617 -2305 140 -69 261 -111 417 -142 162 -32 434 -32 596 0 156 31 277 73 417 142 611 305 960 960 870 1633 -90 680 -603 1223 -1281 1357 -106 21 -375 35 -464 24z m327 -154 c194 -26 338 -71 504 -157 383 -198 657 -562 751 -996 31 -146 31 -418 0 -564 -124 -577 -559 -1011 -1135 -1135 -148 -31 -428 -31 -574 0 -506 109 -913 465 -1082 945 -58 164 -74 271 -74 472 0 147 3 199 21 282 93 433 369 799 751 996 115 60 219 100 321 124 169 40 366 53 517 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120 2795 l0 -455 -455 0 -455 0 0 -90 0 -90 455 0 455 0 0 -460 0 -460 90 0 90 0 0 460 0 460 460 0 460 0 0 90 0 90 -460 0 -460 0 0 455 0 455 -90 0 -90 0 0 -455z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContent);
export default __webpack_public_path__ + "static/media/add-content.5122ca182eaf4a0e5f3cbb09cd44707b.svg";
export { ForwardRef as ReactComponent };